export default "__VITE_ASSET__BtI2Gue5__"